import { SurveyResponse } from './survey-response.model';

export class SurveyInstance {
    id: number;
    title: string;
    description: string;
    questions: SurveyResponse[];
    locked: boolean;
    answered: boolean;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/survey/survey-instance.ts